import { render } from "./MembershipPoint.vue?vue&type=template&id=12ec41df&scoped=true"
import script from "./MembershipPoint.vue?vue&type=script&lang=js"
export * from "./MembershipPoint.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=12ec41df&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12ec41df"]])

export default __exports__